import script from "./LayoutSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LayoutSwitcher.vue?vue&type=style&index=0&id=0d4c4c44&lang=css"

const __exports__ = script;

export default __exports__